import { render, staticRenderFns } from "./DataViewSiblingSidebar.vue?vue&type=template&id=6a984e82&scoped=true&"
import script from "./DataViewSiblingSidebar.vue?vue&type=script&lang=js&"
export * from "./DataViewSiblingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSiblingSidebar.vue?vue&type=style&index=0&id=6a984e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a984e82",
  null
  
)

export default component.exports